import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { painBefore, painAfter } from '../data/content';
export function PainSection() {
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-159" data-mp="2uyfdoqtslb5t">
      <div className="mx-auto max-w-5xl" data-id="element-160" data-mp="2v08cjjy5yr39">
        <div className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="2yz7mjiyr5e1k">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-162" data-mp="2z1tu3iln7tjs">
            ¿Te identificás con alguna de <span className="text-pink" data-id="element-163" data-mp="2pyssnv7q2qmg">estas situaciones</span>?
          </h2>
          <p className="mt-3 text-sm italic text-muted sm:text-base" data-id="element-164" data-mp="2q0vmkqbzx3wg">
            Si respondés sí a una sola, este método fue creado para vos.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-165" data-mp="2g9ixg6hl0ru4">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border border-line border-l-4 border-l-red-300 bg-surface p-6 sm:p-8" data-id="element-166" data-mp="22985f04jd77d">
            <h3 className="mb-5 text-lg font-bold text-foreground sm:text-xl" data-id="element-167" data-mp="3nni8qo0bkh3t">Sin el método</h3>
            <ul className="space-y-3" data-id="element-168" data-mp="5dq44e2r1mdt">
              {painBefore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-169" data-mp="hr8c5f3d23d">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-170" data-mp="38w9lgljw37tu">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="33yrciv5vgslu" />
                  </span>
                  <span className="text-sm leading-relaxed text-muted" data-id="element-172" data-mp="3ine01k5nkqo5">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-primary bg-lilac p-6 sm:p-8" data-id="element-173" data-mp="3dtt2ft7z1yph">
            <h3 className="mb-5 text-lg font-bold text-primary-strong sm:text-xl" data-id="element-174" data-mp="u1veog0bv8kb">
              Con Aprende Coreano Fácil™
            </h3>
            <ul className="space-y-3" data-id="element-175" data-mp="yvzjotq196ir">
              {painAfter.map(item => <li key={item} className="flex items-start gap-3" data-id="element-176" data-mp="12txau23d62os">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary" data-id="element-177" data-mp="65hijy8vdf7z">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-178" data-mp="b4u84qr4l0e9" />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground/85" data-id="element-179" data-mp="f42xljf4uc40">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}